import classNames from "classnames";
import { isString } from "lodash-es";
import React from "react";

import { ITestable, testAttr } from "@/browser";

import { Clear } from "../Clear";
import { IBlurable, IChangeable, IFocusable, IInputBasicProps, IStyleBasicProps } from "../types";
import { withFormElement } from "../withFormElement";
import { Icon, IWithIcon } from "./../../../Icon";
import { positionClass } from "./../../../Style";

export interface ITextInputProps
  extends IInputBasicProps,
    IStyleBasicProps,
    IChangeable,
    IBlurable,
    IWithIcon,
    IFocusable,
    ITestable {
  readOnly?: boolean;
  onClick?: () => void;
  noBorder?: boolean;
}

class TextInputComponent extends React.PureComponent<ITextInputProps> {
  static defaultProps: Partial<ITextInputProps> = {
    size: "md",
    iconPosition: "left",
    autoComplete: "off",
    noBorder: false,
  };

  input: React.RefObject<HTMLInputElement>;

  constructor(props: ITextInputProps) {
    super(props);
    this.input = React.createRef();
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = this.props;
    const value = event.target.value;

    if (onChange) {
      onChange(value);
    }
  };

  handleBlur = () => {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur();
    }
  };

  handleClearClick = () => {
    const { onChange } = this.props;

    if (this.input.current) {
      this.input.current.focus();
    }

    if (onChange) {
      onChange("");
    }
  };

  renderIcon() {
    const { icon, iconPosition, size } = this.props;

    const iconClass = classNames(positionClass("absolute"), "el-form-icon");

    if (icon) {
      return <Icon className={iconClass} position={iconPosition} icon={icon} size={size} square cover />;
    }

    return null;
  }

  render() {
    const {
      className,
      onChange,
      onBlur,
      value,
      type,
      size,
      invalid,
      touched,
      iconPosition,
      icon,
      testName,
      noBorder,
      ...rest
    } = this.props;

    const wrapperClass = classNames(className, positionClass("relative"));
    const textClass = classNames("el-form-text", {
      [`el-form-text--size-${size}`]: !!size,
      "el-form-text--not-valid": invalid,
      "el-no-border": noBorder,
      [`el-form-text--icon-${iconPosition}`]: !!icon,
    });

    const stringValue = isString(value) ? value : "";

    return (
      <span className={wrapperClass}>
        {this.renderIcon()}
        <input
          className={textClass}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={stringValue}
          type={type}
          ref={this.input}
          {...testAttr(this.props, { sufix: "text-input" })}
          {...rest}
        />
        {!this.props.disabled && stringValue && <Clear onClick={this.handleClearClick} />}
      </span>
    );
  }
}

export const TextInput = withFormElement(TextInputComponent);
